import React from "react";
import Presentation from "./presentation";
import OverleafStore from "../../../../../../stores/overleaf-store";

export default class Template extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      showCancelButton: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    // The deck needs to save when the user clicks anywhere else in the decks ul.
    // By handling with native events, we can stop the click event from say entering another deck
    // when the click was supposed to just save
    const el = document.getElementById("create-deck");
    const len = el.value.length;
    el.focus();
    el.selectionStart = len;
    el.selectionEnd = len;
    const decks = document.getElementById("decks");
    decks.addEventListener("click", this.handleSubmit);
  }

  componentWillUnmount() {
    const decks = document.getElementById("decks");
    decks.removeEventListener("click", this.handleSubmit);
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    const params = {
      title: this.state.title,
      metadata: { isbn: this.props.isbn }
    };
    if (this.props.uuid) {
      OverleafStore.updateDeck(this.props.uuid, params).then(this.props.cancel);
      Fraction.Reporter.gaEvent(
        "V3/flashcards/panel",
        this.props.uuid,
        "update deck"
      );
    } else if (this.state.title.length <= 0) {
      this.props.cancel();
    } else {
      OverleafStore.createDeck(params).then(this.props.cancel);
      Fraction.Reporter.gaEvent("V3/flashcards/panel", "", "create deck");
    }
  }

  onChange(e) {
    this.setState({ title: e.currentTarget.value, showCancelButton: true });
  }

  render() {
    return (
      <Presentation
        cancel={this.props.cancel}
        onChange={this.onChange}
        onSubmit={this.handleSubmit}
        value={this.state.title}
        adding={this.props.adding}
        editing={this.props.editing}
      />
    );
  }
}

Template.defaultProps = {
  title: ""
};
